// November 11.11 sale collection callouts.
// Product prices and checkout discounts are managed separately.
(() => {
  "use strict";

  const TV_CALLOUTS = [
  {
    "text": "Soundbar bundle discounts - Ends 12 Nov",
    "handles": [
      "u55-2026",
      "u65-2026",
      "u75-2026",
      "u75-qled-mini-led-google",
      "q43u-2026",
      "q55u-2026",
      "q65u-2026",
      "q75u-2026",
      "q85u-2026",
      "prism-q100-ultra-qled-google-tv",
      "q43qe-2026",
      "q55qe-2026",
      "q65qe-2026",
      "q75qe-2026",
      "s32-google-tv",
      "prism-s40-google-tv",
      "prism-s43-google-tv"
    ]
  },
  {
    "text": "FREE Symphony Soundbar - Ends 11 Nov",
    "handles": [
      "prism-u55-ultra-qd-mini-led-4k-ai-google-tv",
      "prism-u65-ultra-qd-mini-led-4k-ai-google-tv",
      "prism-u75-ultra-qd-mini-led-4k-ai-google-tv",
      "prism-u86-ultra-qd-mini-led-4k-ai-google-tv",
      "prism-55al-google-tv",
      "prism-65al-google-tv"
    ]
  },
  {
    "text": "11.11 SALE: Upsized Discounts - Ends 12 Nov",
    "handles": [
      "prism-roam-27",
      "prism-roam-ultra-27",
      "roam-ultra-32"
    ]
  }
];

  const MONITOR_CALLOUTS = [
  {
    "text": "11.11 SALE: Exclusive Price Drops - Ends 12 Nov",
    "handles": [
      "prism-pg25x-pro",
      "prism-pg27x-pro",
      "prism-pg27f-ultra",
      "prism-pg400u-pro",
      "prism-x490",
      "prism-x490-pro"
    ]
  },
  {
    "text": "11.11 SALE: Upsized Discounts - Ends 12 Nov",
    "handles": [
      "prism-49al",
      "prism-49al-240hz",
      "prism-roam-27",
      "prism-roam-ultra-27"
    ]
  }
];

  const PURIFIER_CALLOUTS = [];

  const FAN_CALLOUTS = [
  {
    "text": "11.11 SALE: Free 4-year full warranty (worth $180)",
    "handles": [
      "prism-oasis",
      "prism-oasis-pro",
      "prism-oasis-pro-macaron"
    ]
  }
];

  const SOUNDBAR_CALLOUTS = [
  {
    "text": "11.11 SALE: Exclusive Price Drops - Ends 12 Nov",
    "handles": [
      "prism-symphony",
      "prism-ripple",
      "prism-rhythm",
      "prism-flow"
    ]
  }
];

  const VACUUM_CALLOUTS = [
  {
    "text": "11.11 SALE: FREE Cleaning Solution + Air Purifier - Ends 12 Nov",
    "handles": [
      "prism-nanobot-elite-ai"
    ]
  },
  {
    "text": "11.11 SALE: Upsized Discount - Ends 12 Nov",
    "handles": [
      "prism-nanobot-pro"
    ]
  },
  {
    "text": "11.11 SALE: FREE EvoHub Elite Stand - Ends 12 Nov",
    "handles": [
      "evosonic-ultra-detect-2-evopod"
    ]
  },
  {
    "text": null,
    "handles": [
      "evosonic-ultra-detect-2-aquamarine",
      "prism-evosonic-ultra-detect-2",
      "prism-evosonic-pro-2-0"
    ]
  }
];

  const FRIDGE_CALLOUTS = [
  {
    "text": "11.11 SALE: Exclusive Price Drops - Ends 12 Nov",
    "handles": [
      "purefresh-tmf-330",
      "purefresh-tmf-420",
      "purefresh-bmf-330",
      "evershine-tmf-420",
      "evershine-tmf-530"
    ]
  },
  {
    "text": "11.11 SALE: FREE Vortex 2c Air Purifier - Ends 12 Nov",
    "handles": [
      "prism-inspire-fdr-570",
      "prism-inspire-sbs-630",
      "purefresh-fdr-440",
      "purefresh-fdr-570",
      "purefresh-sbs-600",
      "purefresh-sbsi-560"
    ]
  }
];

  const LAUNDRY_CALLOUTS = [
  {
    "text": "11.11 SALE: FREE Vortex 2c Air Purifier - Ends 12 Nov",
    "handles": [
      "prism-cyclone-washer-dryer-bundle",
      "prism-monsoon-washer-dryer-bundles-collection-page",
      "laundry-rack-and-washer-bundles-monsoon-collection-page-display",
      "laundry-rack-and-washer-bundles-typhoon-collection-page-display"
    ]
  },
  {
    "text": "11.11 SALE: Upsized Discounts - Ends 12 Nov",
    "handles": [
      "prism-spin-mini-combo"
    ]
  }
];

  const LOCK_CALLOUTS = [
  {
    "text": "11.11 SALE: Upsized Discounts - Ends 12 Nov",
    "handles": [
      "spectre-bundle-2026"
    ]
  }
];

  function renderCallout(label, text) {
    label.textContent = text;
  }

  function toMap(callouts) {
    const map = new Map();

    callouts.forEach(({ text, handles }) => {
      handles.forEach((handle) => map.set(handle, text));
    });

    return map;
  }

  const tvCallouts = toMap(TV_CALLOUTS);

  // All collections that use the standard grid card
  const gridCallouts = toMap([
    ...MONITOR_CALLOUTS,
    ...PURIFIER_CALLOUTS,
    ...FAN_CALLOUTS,
    ...SOUNDBAR_CALLOUTS,
    ...VACUUM_CALLOUTS,
    ...FRIDGE_CALLOUTS,
    ...LAUNDRY_CALLOUTS,
    ...LOCK_CALLOUTS
  ]);


  // ====================================================
  // TV CARD
  // Each size is its own .group-item (inactive sizes
  // are hidden) with the call-out as its first child.
  // ====================================================

  function updateTVCard(card) {
    const handle = card.getAttribute("data-product_handle");

    if (!tvCallouts.has(handle)) return;

    const text = tvCallouts.get(handle);
    let label = card.querySelector(":scope > .product-label");

    // Remove
    if (!text) {
      if (label) label.remove();
      return;
    }

    // Add
    if (!label) {
      label = document.createElement("div");
      label.className = "product-label";
      card.prepend(label);
    }

    // Replace
    renderCallout(label, text);
  }


  // ====================================================
  // STANDARD GRID CARD (product-card-grid-custom)
  // The call-out sits inside .grid-view-item, right
  // after the flash sale banner.
  // ====================================================

  function updateGridCard(card) {
    const handle = card.getAttribute("data-handle");

    if (!gridCallouts.has(handle)) return;

    const item = card.querySelector(".grid-view-item");

    if (!item) return;

    const text = gridCallouts.get(handle);
    let label = item.querySelector(":scope > .v_tag.one_lines");

    // Remove
    if (!text) {
      if (label) label.remove();
      return;
    }

    // Add
    if (!label) {
      label = document.createElement("span");
      label.className = "v_tag one_lines";

      const flashSale = item.querySelector(":scope > .pdpFlashSaleBnrWrap");

      if (flashSale) {
        flashSale.after(label);
      } else {
        item.prepend(label);
      }
    }

    // Replace
    renderCallout(label, text);
  }


  // ====================================================
  // INITIALIZE
  // ====================================================

  function init() {
    document
      .querySelectorAll(".group-item[data-product_handle]")
      .forEach(updateTVCard);

    document
      .querySelectorAll(".v_hoverWrap[data-handle]")
      .forEach(updateGridCard);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
